module.exports = __webpack_public_path__ + "img/radiobutton-checked.e88a01f8.svg";